import * as React from "react";
import {
  Box,
  Chip,
  Grid,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import {
  getSortedListByDate,
  getSortedListByString,
  setSortOrder,
} from "../shared/tables/TableHelper";
import moment from "moment";
import { AuthenticationContext, ImagesContext } from "../Context";
import { useParams } from "react-router-dom";
import { getHeaders } from "../utils/HeaderHelper";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const PatientsListShow: React.FC = () => {
  const { programId } = useParams();
  const images = React.useContext(ImagesContext);
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [program, setProgram] = React.useState<any>();

  const [patients, setPatients] = React.useState<any>(null);
  const [filteredPatients, setFilteredPatients] = React.useState<any>(null);
  const [sortObject, setSortObject] = React.useState<any>({
    field: "created_at",
    direction: "descending",
  });
  const [searchKey, setSearchKey] = React.useState<string>("");

  React.useEffect(() => {
    fetchProgramDetails();
  }, [programId]);

  const fetchProgramDetails = async () => {
    try {
      const response = await fetch(`/programs/${programId}/program_data`, {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      });
      const result = await response.json();
      console.log(result);
      setProgram(result?.program);
      setPatients(result?.patients);
      setFilteredPatients(result?.patients);
    } catch (err) {
      alert("Error fetching patient list info");
      console.error(err);
    }
  };

  const getSortedAndSearchedList = (patients) => {
    let sortedPatients = [...patients];
    sortedPatients.sort((a, b) => (a.id > b.id ? 1 : -1));
    if (sortObject?.field === "date_of_birth") {
      return getSortedListByDate(sortedPatients, sortObject, "date_of_birth");
    } else {
      return getSortedListByString(sortedPatients, sortObject, "last_name");
    }
  };

  const sortList = () => {
    setFilteredPatients((prev) =>
      prev ? getSortedAndSearchedList(prev) : prev
    );
  };

  React.useEffect(() => {
    sortList();
  }, [sortObject]);

  React.useEffect(() => {
    setFilteredPatients((prev) =>
      patients?.filter((patient) => {
        const searchLower = searchKey.toLowerCase();
        return (
          patient.last_name.toLowerCase().includes(searchLower) ||
          patient.first_name.toLowerCase().includes(searchLower)
        );
      })
    );
  }, [searchKey]);

  return (
    <div className="patient-lists-container">
      <div className="container2">
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Grid container>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              className="floating-header"
            >
              <span className="title" title={program?.title}>
                {program?.title.length > 48
                  ? `${program?.title.substring(0, 45)}...`
                  : program?.title}
              </span>
              <Grid item xs={8} className="button-container">
                {patients && patients?.length > 0 && (
                  <div
                    className="pending-add-create-widget"
                    style={{
                      width: 122,
                      height: "auto",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: 30,
                      }}
                    >
                      <div className="on-list">
                        <span className="badge">{patients.length}</span>
                        <span className="on-list-text">On List</span>
                      </div>
                    </div>
                  </div>
                )}
                <Link
                  href="/program-management"
                  sx={{
                    color: "#55504E",
                    textDecoration: "underline",
                    fontSize: "0.8em",
                  }}
                  style={{ paddingLeft: 0 }}
                >
                  Back to Patient Management
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid
              container
              display={"flex"}
              alignItems={"center"}
              justifyContent="space-between"
              className="customer-relation-container"
            >
              <Grid
                item
                xs={5}
                className="association-header"
                sx={{ marginLeft: "0 !important" }}
              >
                <Stack
                  direction={"row"}
                  gap={2}
                  ml={"0px !important"}
                  className=""
                  display={"flex"}
                  alignItems={"center"}
                >
                  <h3>Search Results</h3>
                  <Chip
                    label={searchKey ? filteredPatients.length : "—"}
                    size={"small"}
                    sx={{
                      px: 1,
                      fontFamily: "QuicksandBold",
                    }}
                    style={{ padding: 0 }}
                  />
                </Stack>
              </Grid>
              <Grid
                item
                xs={4}
                className="button-container"
                sx={{ marginTop: "0 !important" }}
              >
                <Grid
                  item
                  xs={12}
                  className="patient-chat-search__box field-container"
                  style={{
                    position: "relative",
                    marginLeft: "0px !important",
                    borderRadius: "5px",
                    maxWidth: "338px",
                  }}
                >
                  <TextField
                    id="last_name"
                    className="textInput plainLabel"
                    placeholder="Search Patient Name"
                    value={searchKey}
                    onChange={(event) => {
                      setSearchKey(event.target.value);
                    }}
                    variant="outlined"
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        borderRadius: "4px",
                        height: 42.25,
                        backgroundColor: "#EFE9E7",
                        width: "100%",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          border: "none",
                        },
                        "&.Mui-focused fieldset": {
                          border: "none",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "#1E1E1E",
                        fontSize: 12,
                        fontWeight: 500,
                        "&::placeholder": {
                          color: "#868382",
                          fontSize: 12,
                          fontWeight: 500,
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <div className="divider"></div>
            <Grid container>
              <Grid
                item
                xs={12}
                className="customer-association-table-container"
              >
                <Box sx={{ overflowX: "auto" }}>
                  <Table
                    className="no-border-table"
                    sx={{ bgcolor: "white", minWidth: "1000px" }}
                  >
                    <TableHead className="table-header-box">
                      <TableRow>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          onClick={() => {
                            setSortOrder(
                              "last_name",
                              sortObject?.direction === "ascending"
                                ? "descending"
                                : "ascending",
                              setSortObject
                            );
                          }}
                          style={{ cursor: "pointer", minWidth: "200px" }}
                        >
                          Patient Name
                          {sortObject?.field === "last_name" ? (
                            <span className="sortIndicator">
                              {sortObject?.direction === "ascending" ? (
                                <img
                                  src={images.sort_ascending_src}
                                  width="10"
                                  className="sort-icon"
                                  alt="Sort Asc"
                                />
                              ) : (
                                <img
                                  src={images.sort_descending_src}
                                  width="10"
                                  className="sort-icon"
                                  alt="Sort Desc"
                                />
                              )}
                            </span>
                          ) : (
                            <span className="sortIndicator">
                              <img
                                src={images.sort_plain_src}
                                width="10"
                                className="sort-icon"
                                alt="Sort Asc"
                              />
                            </span>
                          )}
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "150px" }}
                        >
                          Program Status
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "250px" }}
                        >
                          Program(s)
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "150px" }}
                        >
                          Diagnosis Code(s)
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "150px" }}
                        >
                          Insurance Type(s)
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "200px" }}
                        >
                          Living Facility
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          sx={{ minWidth: "150px" }}
                        >
                          CGM Enrolled?
                        </TableCell>
                        <TableCell
                          component={"th"}
                          className="nowrap-header bold-font-face"
                          onClick={() => {
                            setSortOrder(
                              "date_of_birth",
                              sortObject?.direction === "ascending"
                                ? "descending"
                                : "ascending",
                              setSortObject
                            );
                          }}
                          style={{ cursor: "pointer", minWidth: "150px" }}
                        >
                          Date of Birth
                          {sortObject?.field === "date_of_birth" ? (
                            <span className="sortIndicator">
                              {sortObject?.direction === "ascending" ? (
                                <img
                                  src={images.sort_ascending_src}
                                  width="10"
                                  className="sort-icon"
                                  alt="Sort Asc"
                                />
                              ) : (
                                <img
                                  src={images.sort_descending_src}
                                  width="10"
                                  className="sort-icon"
                                  alt="Sort Desc"
                                />
                              )}
                            </span>
                          ) : (
                            <span className="sortIndicator">
                              <img
                                src={images.sort_plain_src}
                                width="10"
                                className="sort-icon"
                                alt="Sort Asc"
                              />
                            </span>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredPatients?.map((patient) => (
                        <TableRow key={patient.id}>
                          <TableCell
                            sx={{
                              textTransform: "capitalize",
                              minWidth: "150px",
                            }}
                          >
                            <Link
                              href={`/patient_reports/${patient?.id}/action_center`}
                              style={{
                                color: "blue",
                                textDecoration: "underline",
                              }}
                            >
                              {`${patient.last_name}, ${patient.first_name}`}
                            </Link>
                          </TableCell>
                          <TableCell sx={{ minWidth: "120px" }}>
                            <Chip
                              size="small"
                              className="custom-badge on-list"
                              label="On List"
                            />
                          </TableCell>
                          <TableCell sx={{ minWidth: "150px" }}>
                            {patient.programs}
                          </TableCell>
                          <TableCell sx={{ minWidth: "150px" }}>
                            {patient.assigned_diagnoses}
                          </TableCell>
                          <TableCell sx={{ minWidth: "150px" }}>
                            {patient.insurance_type}
                          </TableCell>
                          <TableCell sx={{ minWidth: "200px" }}>
                            {patient.ltc_facility}
                          </TableCell>
                          <TableCell sx={{ minWidth: "150px" }}>
                            {patient.cgm_enabled ? "Yes" : "No"}
                          </TableCell>
                          <TableCell sx={{ minWidth: "150px" }}>
                            {moment(patient?.date_of_birth).format(
                              "MM/DD/YYYY"
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default PatientsListShow;
